import * as React from "react";
import classnames from "classnames";
import { ResponsiveImage } from "@grandvisionhq/elements";
import { useIntersectionObserver } from "@grandvisionhq/lib-utils-react";
/* empty css               */
const LazyImage = ({
  src,
  alt,
  className,
  width,
  height,
  rootMargin = "0px 0px",
  srcSet,
  sizes,
  placeholder,
  isContained
}) => {
  const [ref, inView] = useIntersectionObserver({
    rootMargin,
    freezeOnceVisible: true
  });
  if (!src || !width || !height) {
    console.warn("Width and height are required when using LazyImage");
    return null;
  }
  const renderImage = () => srcSet && sizes ? /* @__PURE__ */ React.createElement(
    ResponsiveImage,
    {
      alt,
      src,
      srcSet,
      sizes,
      isContained
    }
  ) : /* @__PURE__ */ React.createElement("img", { src, alt, width, height });
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ref,
      className: classnames("lazy-image", className),
      style: { paddingBottom: `${height / width * 100}%` }
    },
    inView ? renderImage() : placeholder || null
  );
};
export {
  LazyImage as default
};
//# sourceMappingURL=LazyImage.js.map
